import { AddressAutocompleteInput } from '../../../shared/AddressAutocompleteInput';
import { fieldStyle } from '../../dashboards/primitives';
import { Field } from '../../dashboards/venues/venueCreateFields';
import { CLIENT_SITE_STATE_OPTIONS } from '../usStateNames';

import { requiredProps, TWO_COLUMNS } from './step-layout';
import type { LocationFormApi } from './when-what-form-api';

/** The client-address branch. The region is the one chosen at the top of the
 *  step, so there is no second region field here. */
export default function ClientAddressFields({ form }: { form: LocationFormApi }) {
  const { fields, set, fieldError } = form;
  const text = (key: 'locationName' | 'city' | 'zipCode', label: string) => (
    <Field label={label} required error={fieldError(key)}>
      <input
        aria-label={label}
        {...requiredProps(fieldError(key))}
        value={fields[key]}
        onChange={(e) => set(key, e.target.value)}
        placeholder={key === 'locationName' ? 'e.g. Acme Corp HQ' : undefined}
        style={fieldStyle(fieldError(key) ? 'error' : undefined)}
      />
    </Field>
  );
  return (
    <>
      {text('locationName', 'Location name')}
      <Field label="Address line 1" required error={fieldError('addressLine1')}>
        <AddressAutocompleteInput
          aria-label="Address line 1"
          {...requiredProps(fieldError('addressLine1'))}
          value={fields.addressLine1}
          onChange={(v) => set('addressLine1', v)}
          onPick={(a) => {
            set('addressLine1', a.addressLine1);
            set('city', a.city);
            set('state', a.state);
            set('zipCode', a.zipCode);
          }}
          style={fieldStyle(fieldError('addressLine1') ? 'error' : undefined)}
        />
      </Field>
      {form.withAddressLine2 && (
        <Field label="Address line 2" error={fieldError('addressLine2')}>
          <input
            aria-label="Address line 2"
            aria-invalid={fieldError('addressLine2') ? true : undefined}
            value={fields.addressLine2}
            onChange={(e) => set('addressLine2', e.target.value)}
            style={fieldStyle(fieldError('addressLine2') ? 'error' : undefined)}
          />
        </Field>
      )}
      {text('city', 'City')}
      <div style={TWO_COLUMNS}>
        <Field label="State" required error={fieldError('state')}>
          <select
            aria-label="State"
            {...requiredProps(fieldError('state'))}
            value={fields.state}
            onChange={(e) => set('state', e.target.value)}
            style={fieldStyle(fieldError('state') ? 'error' : undefined)}
          >
            <option value="">Select…</option>
            {CLIENT_SITE_STATE_OPTIONS.map((s) => (
              <option key={s.code} value={s.code}>
                {s.name}
              </option>
            ))}
          </select>
        </Field>
        {text('zipCode', 'ZIP')}
      </div>
    </>
  );
}
